import { useEffect } from "react";

const PrivacyPolicyPage = () => {
  useEffect(() => {
    document.title = "Política de Privacidade - Easyfit";
  }, []);

  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <iframe
        src="/politica-privacidade.html"
        title="Política de Privacidade"
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    </div>
  );
};

export default PrivacyPolicyPage;

